import { render } from "./StatsCreationStyle.vue?vue&type=template&id=3cdc898f&scoped=true"
import script from "./StatsCreationStyle.vue?vue&type=script&lang=js"
export * from "./StatsCreationStyle.vue?vue&type=script&lang=js"

import "./StatsCreationStyle.vue?vue&type=style&index=0&id=3cdc898f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdc898f"]])

export default __exports__